import { observer } from 'mobx-react'
import { FC } from 'react'

import { EMPTY_FILTER_ID } from '@new/domains/operations/screens/CasesV2/CasesV2.constants'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'

import { TruncatedListPreview } from './TruncatedListPreview'

interface CaseOwnersPreviewFormatterProps {
  values?: string[]
}

const _CaseOwnersPreviewFormatter: FC<CaseOwnersPreviewFormatterProps> = ({ values }) => {
  const { ownersByRecordTypes, isLoadingCaseOwners } = casesFilterOptionsStore
  if (isLoadingCaseOwners) return '...'

  const names =
    values
      ?.map(value =>
        value === EMPTY_FILTER_ID
          ? 'N/A'
          : ownersByRecordTypes?.find(option => option?.id === value)?.name,
      )
      .filter((name): name is string => Boolean(name)) ?? []

  return <TruncatedListPreview names={names} />
}

export const CaseOwnersPreviewFormatter = observer(_CaseOwnersPreviewFormatter)
